import axios from "../AxiosInstance"



const getProductsAPI = async (id) => {
    let resolved = {
        data: null,
        error: null
    }

    try {
        let res = await axios({
            url: id ? `/api/products?id=${id}` : `/api/products`,
            method: "GET",
        })
 
        resolved.data = res.data
    } catch (err) {
        if (err.response) {
            resolved.error = err.response.data.message
        } else {
            resolved.error = "SomeThing Went Wrong"
        }
    }
    
   
    return resolved
}

const addProductAPI = async (data) => {
    let resolved = {
        data: null,
        error: null
    }

    try {
        let res = await axios({
            url: `/api/products`,
            method: "POST",
            data
        })
        resolved.data = res.data
    } catch (err) {
        if (err.response) {
            resolved.error = err.response.data.message
        } else {
            resolved.error = "SomeThing Went Wrong"
        }
    }

    return resolved
}

const editProductAPI = async (id, data) => {
    let resolved = {
        data: null,
        error: null
    }

    try {
        let res = await axios({
            url: `/api/products?id=${id}`,
            method: "PUT",
            data
        })
        resolved.data = res.data
    } catch (err) {
        if (err.response) {
            resolved.error = err.response.data.message
        } else {
            resolved.error = "SomeThing Went Wrong"
        }
    }

    return resolved
}

const deleteProductAPI = async (id) => {
    let resolved = {
        data: null,
        error: null
    }

    try {
        let res = await axios({
            url: `/api/products?id=${id}`,
            method: "DELETE",
        })
        resolved.data = res.data
    } catch (err) {
        if (err.response) {
            resolved.error = err.response.data.message
        } else {
            resolved.error = "SomeThing Went Wrong"
        }
    }

    return resolved
}

export { getProductsAPI, addProductAPI, editProductAPI, deleteProductAPI }